
var client_id = $("#instafeed").data("client_id");
var User_Id = $("#instafeed").data("user_id");
var Access_Token = $("#instafeed").data("access_token");
var limit = $("#instafeed").data("limit");


var userFeed = new Instafeed({
    get: 'user',
    userId: User_Id,
    accessToken: Access_Token,
    limit: limit,
    resolution: 'standard_resolution',
    clientId: client_id,
    template: '<a href="{{link}}" target="_blank" class="insta_item"><img src="{{image}}" /><div class="overlay"><ul><li>{{likes}}<span><i class="fa fa-heart" aria-hidden="true"></i></span></li> <li>{{comments}}<span><i class="fa fa-comments" aria-hidden="true"></i></span></li></ul></div></a>'
});

userFeed.run();